import React, {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import {selectKP11SelectCartCentersNApps} from '../../../../../../app-store/kp11CartSlice'
import {
  CardPlanBodyStyle,
  CardPlanAddToCartStyle,
} from '../kp-11Link-catalog-cards-style'
import {kpSuccessIcon} from '../../../../../../assets'
import {PlanRadioInput} from '../../../kp-11Link-reusable-components/kp-plan-radio-input'
import {CardPlanItemWrapStyle} from '../../../kp-11Link-reusable-components/kp-plan-radio-input-style'
import {DELAY_HIDE_IN_SEC} from '../../../../../../utils/constants'
import {
  buildCartEntity,
  getItemFromCart,
} from '../../../kp-11Link-utility/kp11-utility'

export const KP11LinkGPCardComponent = ({
  groupKey,
  items = [],
  onSelectItem,
  disabled,
  addedToCart,
  selectedCountry = 'US',
}) => {
  // Get selectedItem from structured cart
  const cartCentersAndApps = useSelector(selectKP11SelectCartCentersNApps)
  const selectedItem = getItemFromCart({
    cartCentersAndApps,
    groupKey,
    items,
  })
  const [add2CartBannerStatus, setAdd2BannerStatus] = useState(addedToCart)
  useEffect(() => {
    if (addedToCart) {
      setAdd2BannerStatus(true)
      setTimeout(() => {
        setAdd2BannerStatus(false)
      }, DELAY_HIDE_IN_SEC * 1000)
    }
  }, [addedToCart])

  // --- Known growth package codes ---
  const STARTER_CODE = 'addon-5-mcstartgr'
  const EXPANDED_CODE = 'addon-5-mcexpangr'

  const starterIsAlreadyAdded = items.some(
    i => i.code === STARTER_CODE && i.isAlreadyAdded,
  )
  const expandedIsAlreadyAdded = items.some(
    i => i.code === EXPANDED_CODE && i.isAlreadyAdded,
  )

  // --- Determine checked and disabled state ---
  const getItemState = item => {
    const isStarter = item.code === STARTER_CODE
    const isExpanded = item.code === EXPANDED_CODE
    const selectedCode = selectedItem?.code

    // Expanded already added
    if (expandedIsAlreadyAdded) {
      return {checked: isExpanded, disabled: true}
    }

    // Starter already added
    if (starterIsAlreadyAdded) {
      if (selectedCode === EXPANDED_CODE) {
        return {checked: isExpanded, disabled: isStarter}
      }
      return {checked: isStarter, disabled: isStarter}
    }

    // Default case
    return {checked: selectedCode === item.code, disabled: false}
  }

  return (
    <CardPlanBodyStyle>
      <div className="card-plan-subText">Select a Growth Package</div>

      <CardPlanItemWrapStyle>
        {items.map(item => {
          const {checked, disabled: isDisabled} = getItemState(item)
          return (
            <PlanRadioInput
              key={item.code}
              item={item}
              checked={checked}
              disabled={disabled || isDisabled}
              onChange={() => {
                const updatedItem = buildCartEntity({
                  kind: 'item',
                  source: item,
                })
                onSelectItem(updatedItem)
              }}
              country={selectedCountry}
            />
          )
        })}
      </CardPlanItemWrapStyle>

      {add2CartBannerStatus && (
        <CardPlanAddToCartStyle>
          <img src={kpSuccessIcon} alt="success icon" />
          <span>Added to cart</span>
        </CardPlanAddToCartStyle>
      )}
    </CardPlanBodyStyle>
  )
}
